import React, { useEffect,useRef, useState ,IonLoading } from 'react'
import './style.css';
import {Link} from 'react-router-dom';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Helmet } from 'react-helmet';
import {ApiService} from '../../containers/Services/apiservice';
import {useHistory} from 'react-router-dom';
import {Watch} from "react-loader-spinner";
let apiServices = new ApiService();
const Home = () =>{
    const [pageContent, setPageContent] = useState('');
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const [pageKeywords, setPageKeywords] = useState('');
    const [pageDescription, setPageDescription] = useState('');
    const [setClientBaseUrl, setImageUrl] = useState('');
    const [setDefaultBaseUrl, setDefultImageUrl] = useState('');
    const [blogsData, setBlogsData] = useState([]);
    const [baseUrl, setBaseUrl] = useState('');
    const [clientData, setClientData] = useState([]);
    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) { 
            const dataString = {
                "url": 'home'
            }
            apiServices.pagesPostRequest(dataString).then(res => {
                if(res.data.status=='success'){
                    setPageContent(res.data.data.page_content);
                    setPageTitle(res.data.data.page_name);
                    setPageKeywords(res.data.data.page_meta_keyword);
                    setPageDescription(res.data.data.page_meta_desc);
                }
            })
            apiServices.getClientsData().then(res => {
                if(res.data.status=='success'){
                
                    setClientData(res.data.data);
                    setImageUrl(res.data.image_url);
                    setDefultImageUrl(res.data.default_img);
                }
            })
            apiServices.getfeaturedblogs() 
            .then(res => {
              if(res.data.status=='success'){
                setBlogsData(res.data.data);
                setBaseUrl(res.data.baseurl);
                return;
              }
            })
            .catch(error => {
                }) 
        }
        didMountRef.current = false;
      }); 
   return (
    <div>
        <Header/>
        <Helmet>
        <title>{pageTitle} - Goalstox</title> 
        <meta name="keywords" content={pageKeywords}/> 
        <meta name="description" content={pageDescription} />
        </Helmet>            
            <span dangerouslySetInnerHTML={{ __html: pageContent }} ></span>
            <section className='bg-grey'>
            <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                <div className='overlay-box'>     
                    <Watch
                        color="#ffffff"
                        visible={spinnerLoading}
                        />
                    </div>
                </div>
               <div className="container-fluid">
                    <div className="section-title tx-center">
                        <h2>Keep Learning, Keep Growing</h2>
                        <p>Keeping your investment portfolio simple, diversified, and sticking to your asset allocation is more important than trying to pick individual winning stocks. Your investment risk profile is more important than trying to catch every fancy investment product. Keep it simple.</p>
                    </div>
                    <div className="row">
                    {
                       blogsData.map(key =>
                            <div className="col-md-4" >
                            <div className="blogbox">
                                <div className="blogbox-img">
                                <Link to={`/blog-detail/${key.blog_slug}`}>
                                    {
                                    key.blog_image!=''?<img src={baseUrl+key.blog_image} />:<img src="https://www.codexocoder.com/2022/goalstox/public/img/uploads/blog_image/1649328888.webp" />
                                    } 
                                </Link>
                                </div>
                                <div className="blogbox-content">
                                <div className="blog-meta">
                                <div className="blog-meta-date">{key.datetime} </div>
                                <div className="blog-meta-category">
                                    <ul>
                                        {
                                        key.blog_category_id.map(cat =><li><Link to={`/blog-category/${cat.category_slug}`}>{cat.category_name}</Link></li>)
                                        }                                           
                                    </ul>
                                </div>
                                </div>
                                <div className="blogbox-title">  <Link to={`/blog-detail/${key.blog_slug}`}>{key.blog_name}</Link></div>
                                <Link to={`/blog-detail/${key.blog_slug}`} className="btn-icon"><i className ="fa fa-angle-right" aria-hidden="true"></i></Link>
                            </div>
                            </div>
                            </div>
                        )
                    }
                    </div>
                   {/*  <div className="tx-center mg-t-20">
                        <Link to="/blog">View all articles <i className="icon-arrow-right8 ml-5"></i></Link>
                    </div> */}
                </div>
            </section>
            {
                clientData.length>0?<section>
                <div className="container-fluid">
                    <div className="section-title tx-center">
                        <h2>Our Affiliates </h2>
                    </div>
                  <div className="row justify-content-md-center">
                    {
                      clientData.map(key =>
                        <div className="col-md-2 col-6" >
                            <div className="clientbox">
                                {
                                  key.op_image!=null?<img src={setClientBaseUrl+key.op_image} />:<img src={setDefaultBaseUrl} />
                                } 
                            </div>
                        </div>
                      )
                    }
                  </div>
                </div>
            </section>:null
            }            
        <Footer/>
    </div>
);

}
export default Home;